import { motion } from "framer-motion";
import clsx from "clsx";
import Marquee from "react-fast-marquee";
import useMobile from "src/hooks/useMobile";
import useDarkMode from "src/hooks/useDarkMode";
import { memo, ReactElement } from "react";

interface IMarqueeRow {
  text?: string | null;
  children?: ReactElement;
}

const MarqueeRow: React.FC<IMarqueeRow> = ({
  text = null,
  children = null,
}) => {
  const { isMobile } = useMobile();
  const { isEnabled: isDarkMode } = useDarkMode();

  if (!text && !children) return null;

  return (
    <div
      className={clsx([
        "bg-blue-900",
        "md:bg-blue-200",
        "dark:bg-gray-900",
        "dark:md:bg-gray-900",
        "flex",
        "w-full",
        "md:rounded-full",
        "md:overflow-hidden",
        "md:max-w-[90%]",
        "md:mx-auto",
      ])}
    >
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 2, ease: "easeOut" }}
        className={clsx(["flex", "w-full"])}
      >
        <Marquee
          autoFill
          gradient
          gradientColor={
            isDarkMode
              ? "rgb(17 24 39 / 1)"
              : isMobile
              ? "rgb(30 58 138 / 1)"
              : "rgb(255 255 255 / 1)"
          }
          gradientWidth={isMobile ? 40 : 60}
        >
          <div
            className={clsx([
              "mx-3",
              "md:mx-5",
              "text-xs",
              "text-white",
              "md:text-blue-800",
              "dark:text-cyan-400",
              "dark:md:text-cyan-400",
              "md:text-sm",
              "font-normal",
              "py-1",
            ])}
          >
            {children ? <>{children}</> : text ? text : <></>}
          </div>
        </Marquee>
      </motion.div>
    </div>
  );
};

export default memo(MarqueeRow);
